module.exports = __webpack_public_path__ + "static/media/book.287fe2b8.png";